<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="error">
            <nav-bar-box :extr="navData"></nav-bar-box>
            <div class="accountsReceive">
                <timeNodeFiltering ref="timeNodeFiltering" :is-specify-date="true" @selectNodeCallback="getData"></timeNodeFiltering>
                <div class="main">
                    <div class="top">
                        <div class="header">
                            <div class="item item0">
                                <p class="describe">
                                    合计
                                </p>
                                <p class="num">
                                    {{ detailVal.total_sales_volume }}
                                </p>
                            </div>
                            <!-- <div class="border_1"></div> -->
                            <!-- <div class="item">
                                <p class="describe2">
                                    可膨胀
                                </p>
                                <p class="num2">
                                    {{ detailVal.expandable_graphite_sales_volume }}
                                </p>
                            </div> -->
                            <div class="item">
                                <p class="describe2">
                                    球形
                                </p>
                                <p class="num2">
                                    {{ detailVal.spherical_graphite_sales_volume }}
                                </p>
                            </div>
                            <div class="item">
                                <p class="describe2">
                                    提纯
                                </p>
                                <p class="num2">
                                    {{ detailVal.purified_graphite_sales_volume }}
                                </p>
                            </div>
                            <div class="item">
                                <p class="describe2">
                                    负极
                                </p>
                                <p class="num2">
                                    {{ detailVal.negative_sales_volume }}
                                </p>
                            </div>
                            <div class="item">
                                <p class="describe2">
                                    尾料
                                </p>
                                <p class="num2">
                                    {{ detailVal.tail_sales_volume }}
                                </p>
                            </div>
                            <div class="item">
                                <p class="describe2">
                                    其他
                                </p>
                                <p class="num2">
                                    {{ detailVal.other_sales_volume }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="chart-con">
                        <div id="recovery-chart"></div>
                    </div>
                    <div class="split"></div>
                    <div class="chart-con">
                        <div class="btn_box">
                            <van-button size="small" class="bz_btn" type="danger">
                                本周趋势
                            </van-button>
                            <van-button
                                @click="goListFun"
                                class="xs_btn"
                                size="small"
                                plain
                                type="danger"
                            >
                                销售日报
                            </van-button>
                        </div>
                        <div id="balance-chart"></div>
                    </div>
                </div>
            </div>
        </div>
    </v-touch>
</template>

<script>
import timeNodeFiltering from '@/components/timeNodeFiltering/index.vue';
export default {
    components: { timeNodeFiltering },
    props: {},
    data() {
        return {
            navData: {
                title: '黑龙江销售日报',
                leftText: '',
                rightText: '',
                leftArrow: true,
            },
            listData: [], // 列表数据

            detailVal: {},
            tableData: [],
        };
    },
    mounted() {},
    methods: {
        // 返回上一页
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
        goListFun() {
            this.$router.isBack = 2;
            const params = {
                tableData: JSON.stringify(this.tableData),
                date: this.$refs.timeNodeFiltering.specifyDate,
            };
            this.$router.replace({ name: 'hljSalesDailyList', params });
        },
        // 获取数据
        getData(start_date, end_date) {
            this.$toast.loading({ overlay: true, duration: 0 });
            const path = `/interfaceApi/report/report/hlj/sales_day_report?start_date=${start_date}&end_date=${end_date}`;
            return this.$axios.get(path).then(res => {
                if (res) {
                    this.detailVal = res.total;
                    this.tableData = res.details;
                    this.pieChart('recovery-chart', res.total);
                    this.lineColumn('balance-chart', res.days);
                }
                this.$toast.clear();
            });
        },
        lineColumn(obj, listData) {
            const data = [];
            const xData = [];

            listData.forEach(item => {
                data.push(item.total_sales_volume);
                xData.push(item.report_date.substring(5, 10));
            });
            const lineColumnChart = window.$globalHub.$echarts.init(document.getElementById(obj));
            const option = {
                title: {
                    text: '销售量',
                    left: 'left',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                        label: {
                            show: true,
                        },
                    },
                },
                legend: false,
                grid: {
                    left: 50,
                    top: 60,
                    right: 20,
                    bottom: 40,
                },
                xAxis: [{
                    // type:'category',
                    data: xData,
                    boundaryGap: true,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: 'rgba(133,133,133,0.2)',
                        },
                    },
                    splitArea: {
                        color: '#f00',
                        lineStyle: {
                            color: '#f00',
                        },
                    },
                    axisLabel: {
                        color: '#979EA7',
                    },
                    splitLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                }],
                yAxis: [
                    {
                        name: '',
                        nameLocation: 'end',
                        position: 'left',
                        nameTextStyle: {
                            color: '#979EA7',
                            padding: '',
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(255,255,255,0.1)',
                                width: 0.5,
                                type: 'dashed',
                            },
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(133,133,133,0.2)',
                            },
                        },
                        axisLabel: {
                            show: true,
                            color: '#979EA7',
                        },
                        axisTick: {
                            show: false,
                        },
                    },
                    {
                        name: '',
                        nameLocation: 'end',
                        position: 'left',
                        nameTextStyle: {
                            color: '#979EA7',
                            padding: '',
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(133,133,133,0.2)',
                                width: 0.5,
                                type: 'solid',
                            },
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(133,133,133,0.2)',
                            },
                        },
                        axisLabel: {
                            show: true,
                            color: '#979EA7',
                        },
                        axisTick: {
                            show: false,
                        },
                    },
                ],
                series: [
                    {
                        name: '销售量',
                        type: 'line',
                        // smooth: true,
                        showSymbol: true,
                        symbolSize: 8,
                        lineStyle: {
                            normal: {
                                color: '#FA8436',
                                width: 2,
                            },
                        },
                        yAxisIndex: 1,
                        label: {
                            show: true,
                            position: 'top',
                            textStyle: {
                                color: '#FC9343',
                            },
                        },
                        itemStyle: {
                            color: '#6c50f3',
                            borderColor: '#fff',
                            borderWidth: 2,
                            shadowColor: '#FA8436',
                            shadowBlur: 0,
                            shadowOffsetY: 2,
                            shadowOffsetX: 2,
                            normal: {
                                color: '#FA8436',
                                lineStyle: {
                                    color: '#FA8436',
                                },
                            },
                        },
                        areaStyle: {
                            normal: {
                                color: new window.$globalHub.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#FA8436',
                                }, {
                                    offset: 1,
                                    color: '#fff',
                                }], false),
                            },
                        },
                        data: data,
                    },
                ],
            };
            lineColumnChart.setOption(option);
        },

        pieChart(obj, listData) {
            const chart = window.$globalHub.$echarts.init(document.getElementById(obj));
            // 默认四种渐变颜色
            const colors = [
                ['#6D6B7B', '#6D6B7B'],
                ['#ED6967', '#ED6967'],
                ['#5D7092', '#5D7092']];

            const data = [
                {
                    name: '球形',
                    value: listData.spherical_graphite_sales_volume,
                },
                {
                    name: '提纯',
                    value: listData.purified_graphite_sales_volume,
                },
                {
                    name: '负极',
                    value: listData.negative_sales_volume,
                },
                {
                    name: '尾料',
                    value: listData.tail_sales_volume,
                },
                {
                    name: '其他',
                    value: listData.other_sales_volume,
                },
            ];
            let total = 0;
            data.forEach(item => {
                total += Number(item.value);
            });
            data.forEach(item => {
                if (total === 0) {
                    item.name += '(0%)';
                } else {
                    item.name += '(' + (Number(item.value) / total * 100).toFixed(1) + '%)';
                }
            });
            const result = [];
            data.forEach((item, index) => {
                const obj = {
                    value: item.value,
                    name: item.name,
                    label: {
                        alignTo: 'edge',
                        formatter: '{name|{b}} \n{value|{c}吨}',
                        minMargin: 5,
                        edgeDistance: 10,
                        lineHeight: 18,
                        rich: {
                            name: {
                                fontSize: 11,
                                color: '#666',
                            },
                            value: {
                                fontSize: 11,
                                color: '#666',
                            },
                        },
                    },
                };
                if (index < colors.length) {
                    obj.itemStyle = {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: colors[index][0], // 0% 处的颜色
                            }, {
                                offset: 1, color: colors[index][1], // 100% 处的颜色
                            }],
                            global: false, // 缺省为 false
                        },
                    };
                }
                result.push(obj);
            });
            const option = {
                title: {
                    text: '统计图',
                    left: 'left',
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['40%', '55%'],
                        center: ['50%', '55%'],
                        selectedMode: 'single',
                        data: result,
                        itemStyle: {
                            borderRadius: 2,
                            borderColor: '#fff',
                            borderWidth: 2,
                        },
                        labelLayout: function (params) {
                            const isLeft = params.labelRect.x < chart.getWidth() / 2;
                            const points = params.labelLinePoints;
                            // Update the end point.
                            points[2][0] = isLeft
                                ? params.labelRect.x
                                : params.labelRect.x + params.labelRect.width;

                            return {
                                labelLinePoints: points,
                            };
                        },
                        emphasis: {
                            show: false,
                        },
                    },
                ],
            };
            chart.setOption(option);
        },
    },
};
</script>
<style lang="stylus" scoped>
.accountsReceive
    background #fff
    width 100%
    height calc(100vh - 70rpx)
    overflow-y: scroll
    .charts_header
        margin 12rpx 30rpx
        .van-tabs__nav
            margin 0
    .search-conditions-con
        padding 10rpx
    .main
        .top
            padding 0 10rpx 10rpx 10rpx
            h4
                margin-top 10rpx
                span
                    font-size 12rpx
                    color #979EA7
            .header
                display flex
                flex-wrap: wrap;
                margin-top 2rpx
                background repeating-linear-gradient(to left, #F79187, #EA5D5D)
                border-radius 4rpx
                padding 10rpx 0
                .item
                    flex-shrink 0
                    min-width calc(100%/3)
                    flex 1
                    text-align center
                    padding 3rpx 0 5rpx 0
                    color #fff
                    &:nth-of-type(1)
                        border-right 3rpx solid #FC8785
                    .num
                        font-size 24rpx
                    .num2
                        font-size 20rpx
                        margin-top 6rpx
                    .describe
                        font-size 18rpx
                        margin-bottom 3rpx
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                        line-height 25rpx
                    .describe2
                        font-size 16rpx
                        margin-bottom 3rpx
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                        line-height 25rpx
            table
                width 100%
                border-spacing 0px
                border-collapse collapse
                margin-top 10rpx
                table-layout fixed
                th
                    background rgba(235,240,252,1)
                    height 45rpx
                    border 2.5rpx solid #fff
                    border-collapse collapse
                    font-size 14rpx
                    font-weight normal
                td
                    border 2.5rpx solid #fff
                    border-collapse collapse
                    height 45rpx
                    text-align center
                    width 40rpx
                    font-size 14rpx
                    background rgba(85,136,241,.04)
                    width 25%
                    color #5588F1
                    &.row-tit
                        color #333333
                        background rgba(235,240,252,1)
                tbody
                    tr
                        &.activeRow
                            td
                                background rgba(250,132,54,1)
                                box-shadow 1px 1px 4px 0px rgba(0,0,0,0.3)
                                color #fff
                            .row-tit
                                color #823802
                                background rgba(245,242,237,1)
                                box-shadow 1px 1px 4px 0px rgba(0,0,0,0.3)
                                border 1px solid rgba(222,227,239,1)
        .split
            background #F0F0F0
            height 15rpx
        .chart-con
            padding 10rpx
            position relative
            .btn_box
                position absolute
                right 4rpx
                top 4rpx
                z-index 99
                .xs_btn
                    margin-left 5rpx
                    border: 1px solid #E93743;
                .bz_btn
                    background: linear-gradient(138deg, #EB6348 0%, #E93543 100%);
                    border: none
            h4
                margin 10rpx 0
            #balance-chart
                height 260rpx
            #recovery-chart
                height 265rpx
>>>.van-calendar
    .van-calendar__day
        color red
        font-weight: 600;
    .van-calendar__day--disabled
        color #c8c9cc
        font-weight: 400;
</style>
